import { useContext, useState } from 'react';
import { AppCtx } from 'pages/_app';
import { MapPin } from 'lucide-react';
import settings from '@/settings';
import { ZipcodeStateData } from '@/lib/use-customer-zipcode';
import i18n from '@/settings/i18n';

import DeliverToModal from './DeliverToModal';

const t = i18n.init('shared');

const formatLocation = (data: ZipcodeStateData) =>
  `${(data.region ?? data.stateName).replace(
    ' Metro',
    '',
  )} ${data.zipcode?.toUpperCase()}`;

const DeliverTo = ({ hideMenu }: { hideMenu: boolean }) => {
  const { setZipcodeStateData, zipcodeStateData } = useContext(AppCtx);
  const [isDeliverByOpen, setIsDeliverByOpen] = useState(false);

  if (!['reebelo-au', 'reebelo-nz', 'reebelo-ca'].includes(settings.store)) {
    return null;
  }

  const handleStateNameChange = (data: ZipcodeStateData) => {
    setZipcodeStateData(data);
  };

  if (hideMenu) {
    return null;
  }

  return (
    <>
      <button
        className="hidden shrink-0 items-center gap-3 self-center border-r pr-6 text-left outline-none lg:flex"
        onClick={() => setIsDeliverByOpen(true)}
      >
        <MapPin className="h-4 w-4 shrink-0" strokeWidth={2} />
        <div className="min-w-[13.5rem] text-sm">
          {zipcodeStateData?.isDefault ? (
            <>
              <div className="flex items-center gap-1 leading-tight text-gray-700/50">
                {`${t`Deliver to`} ${formatLocation(zipcodeStateData)}`}
              </div>
              <div className="leading-tight text-gray-700">
                {t`To change, select your postcode`}
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center gap-1 leading-tight text-gray-700/50">
                {t`Deliver to`}
              </div>
              <div className="leading-tight text-gray-700">
                {zipcodeStateData ? formatLocation(zipcodeStateData) : '-'}
              </div>
            </>
          )}
        </div>
      </button>
      <DeliverToModal
        isOpen={isDeliverByOpen}
        onClose={() => setIsDeliverByOpen(false)}
        onStateNameChange={handleStateNameChange}
      />
    </>
  );
};

export default DeliverTo;
